import { PageSectionsContactSection } from '@/tina/__generated__/types';
import * as stylex from '@stylexjs/stylex';
import { tinaField } from 'tinacms/dist/react';
import { layout } from '../styles/layout';
import '../styles/tokens.stylex';
import { fontWeights, spacing } from '../styles/tokens.stylex';
import { typography } from '../styles/typography';
import { Button } from './Buttons';
import { LinkButton } from './Buttons/LinkButton';
import { InlineForm } from './HubspotForm/InlineForm';
import { NextLinkWithEventPayload } from './NextLinkWithEventPayload';
import { PageSection } from './PageSection';
interface ContactSectionProps {
  data: PageSectionsContactSection;
}
export function ContactSection({
  data
}: ContactSectionProps) {
  return data ? <PageSection styles={sx.sectionLayout}>
      {data.globalsReference && <div {...stylex.props(layout.contentCard, sx.cardGridLayout)}>
          <h1 {...stylex.props(typography.heading1)}>
            A&O 3PL and Direct Mail Fulfilment
          </h1>
          {<div>
              <Button asChild iconLeft="phone" leftAlign>
                <NextLinkWithEventPayload href={`tel:${data.globalsReference.companyInfo?.telephoneNumberLink}`} clickEventPayload={{
            event: 'phone_call_click',
            location: 'contactUsBlock'
          }}>
                  {data.globalsReference.companyInfo?.telephoneNumber}
                </NextLinkWithEventPayload>
              </Button>
            </div>}
          <div className="xrvj5dj x16pmaob">
            <h2 {...stylex.props(typography.heading2)} data-tina-field={tinaField(data, 'globalsReference')}>
              Warehouse Address
            </h2>
            <p {...stylex.props(typography.body)}>
              {data.globalsReference.companyInfo?.address1}
              {data.globalsReference.companyInfo?.address2 && <>
                  <br />
                  {data.globalsReference.companyInfo?.address2}
                </>}
              {data.globalsReference.companyInfo?.address3 && <>
                  <br />
                  {data.globalsReference.companyInfo?.address3}
                </>}
            </p>
            {data.globalsReference.companyInfo?.addressLink && <LinkButton href={data.globalsReference.companyInfo?.addressLink as string} styles={sx.justifyStart} clickEventPayload={{
          event: 'address_click',
          location: 'contactUsBlock'
        }}>
                Google Maps
              </LinkButton>}
          </div>
          {data.globalsReference.companyInfo?.openingHours && <div className="xrvj5dj x16pmaob">
              <h2 {...stylex.props(typography.heading2)} data-tina-field={tinaField(data, 'globalsReference')}>
                Opening Hours
              </h2>
              <table className="x1lqcxt8">
                <tbody>
                  {data.globalsReference.companyInfo?.openingHours?.map((e, i) => {
              return <tr key={`${i}-${e?.day}`} className="x1neli0u">
                          <td className="x1d0kp7d x19n2uve">
                            {e?.day + ':'}
                          </td>
                          <td>
                            {e?.timeFrom}
                            {e?.timeTo ? `–${e.timeTo}` : ``}
                          </td>
                        </tr>;
            })}
                </tbody>
              </table>
            </div>}
        </div>}
      {data.contactForm?.formId && <div {...stylex.props(layout.contentCard, sx.cardGridLayout)}>
          <div>
            <h1 {...stylex.props(typography.heading1)} data-tina-field={tinaField(data, 'contactForm')}>
              Get in touch
            </h1>
            <p {...stylex.props(typography.body)}>
              For general email enquiries, please submit the form below.
            </p>
          </div>
          <InlineForm formId={data.contactForm.formId} />
        </div>}
    </PageSection> : null;
}
const sx = {
  sectionLayout: {
    k1xSpc: "x78zum5",
    kwnvtZ: "x1a02dak",
    $$css: true
  },
  cardGridLayout: {
    kUk6DE: "x98rzlu",
    k1xSpc: "xrvj5dj",
    kfiyM8: "x10ukxgv",
    kOIVth: "x1mhrlx8",
    k7Eaqz: "x17upfok",
    $$css: true
  },
  justifyStart: {
    kFhvOy: "x1lqcxt8",
    $$css: true
  }
};